import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {
  constructor(private myRoute: Router) { }
  getToken() {
    return localStorage.getItem('LogInDetails');
  }
  isLoggedIn() {
    return this.getToken() !== null;
  }

  getAdminToken() {
    return localStorage.getItem('AdminDetails');
  }

  isAdminLoggedIn() {
    return this.getAdminToken() !== null;
  }
}
